__turbopack_context__.v({
  "CategoryCard": "CategoryList-module__6YiaeW__CategoryCard",
  "CategoryList": "CategoryList-module__6YiaeW__CategoryList",
  "bottom": "CategoryList-module__6YiaeW__bottom",
  "list": "CategoryList-module__6YiaeW__list",
  "title": "CategoryList-module__6YiaeW__title",
  "top": "CategoryList-module__6YiaeW__top",
});
